module.exports = __webpack_public_path__ + "img/logo.16db6c73.png";